<template>
  <div class="container-fluid py-4">

    <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-journal-medical fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Consultations</h2>
      </div>
      <!--<button class="btn btn-primary btn-lg shadow-sm btn-clinique mt-2 mt-md-0" @click="creation">
        <i class="bi bi-plus-circle me-1"></i> Nouvelle Consultation
      </button>-->
    </div>

    <!-- Filtres -->
    <div class="card p-3 mb-4 shadow-sm rounded card-clinique">
      <div class="row g-3 align-items-end">
        <div class="col-12 col-md-3">
          <label class="form-label fw-semibold">Rechercher</label>
          <input v-model="searchQuery" placeholder="Nom, téléphone, type..." class="form-control form-control-clinique" />
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Items par page</label>
          <select v-model="itemsperpage" class="form-select form-select-clinique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">{{ item }}</option>
          </select>
        </div>
        <div class="col-6 col-md-3">
          <label class="form-label fw-semibold">Trier par</label>
          <select v-model="orderBy" class="form-select form-select-clinique">
            <option v-for="(value, key) in orderByTabs" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Ordre</label>
          <select v-model="sortOrder" class="form-select form-select-clinique">
            <option v-for="(value, key) in sortOrders" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
      </div>
    </div>
     <!-- Loader -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;"></div>
      <p class="mt-3">Chargement des consultations...</p>
    </div>

    <!-- Tableau moderne -->
    <div v-else class="card shadow-sm rounded card-clinique">
      <div class="table-responsive overflow-auto">
        <table class="table align-middle text-center mb-0 table-hover modern-table-clinique w-100">
          <thead>
            <tr>
              <th>#</th>
              <th>N° Consultation</th>
              <th>Date</th>
              <th>Nom</th>
              <th>Prénom</th>
              <th class="d-none d-sm-table-cell">Téléphone</th>
              <th class="d-none d-md-table-cell">Type</th>
              <th class="d-none d-md-table-cell">Paiement</th>
              <th >Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(consultation, index) in filteredConsultations" :key="consultation.id">
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
              <td>{{ consultation.numConsultation }}</td>
              <td>{{ formatDate(consultation.createdAt) }}</td>
              <td>{{ consultation.patient_nom }}</td>
              <td>{{ consultation.patient_prenom }}</td>
              <td class="d-none d-sm-table-cell">{{ consultation.patient_telephone || '—' }}</td>
              <td class="d-none d-md-table-cell">{{ consultation.type_nom || '—' }}</td>
              <td class="d-none d-md-table-cell">
                <span :class="consultation.estPaye === 'Payé' ? 'text-success' : 'text-warning'">
                  {{ consultation.estPaye || '—' }}
                </span>
              </td>
              <td >
                <span :class="consultation.statut === 'Terminée' ? 'text-success' : 'text-danger'">
                  {{ consultation.statut || '—' }}
                </span>
              </td>
              <td>
                <div class="dropdown">
                  <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li v-if="$store.getters.hasPermission('PATIENT_DOSSIER')">
                      <a class="dropdown-item" @click="dossier(consultation.patient_id)">Dossier</a>
                    </li>
                     <li v-if="$store.getters.hasPermission('CONSULT_TRAITER')">
                      <a class="dropdown-item" @click="traiterConsultation(consultation)">Traitement</a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="consultations.length === 0">
              <td colspan="9" class="text-center py-3">Aucune consultation disponible</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-end p-3">
        <ul class="pagination pagination-modern flex-wrap mb-0">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
          </li>
          <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      isLoading: true,
      isFirstLoad: true,
      searchQuery: '',
      itemsperpage: 50,
      orderBy: 'co.createdAt',
      sortOrder: 'DESC',
      consultations: [],
      totalItems: 0,
      currentPage: 1,
      itemsPerPageT: [50, 100, 150, 200],
      orderByTabs: { Date: 'co.createdAt', Statut: 'co.statut' },
      sortOrders: { Croissant: 'ASC', Décroissant: 'DESC' }
    };
  },
  computed: {
    totalPages() { return Math.ceil(this.totalItems / this.itemsperpage); },
    filteredConsultations() {
      if (!this.searchQuery) return this.consultations;
      const q = this.searchQuery.toLowerCase();
      return this.consultations.filter(c =>
        c.patient?.nom?.toLowerCase().includes(q) ||
        c.patient?.prenom?.toLowerCase().includes(q) ||
        c.patient?.telephone?.toLowerCase().includes(q) ||
        c.type?.nom?.toLowerCase().includes(q) ||
        c.numConsultation.toLowerCase().includes(q)
      );
    }
  },
  methods: {
    formatDate(date) { return dayjs(date).format('DD-MM-YYYY HH:mm'); },
    dossier(id) { 
      
      this.$router.push({ name: 'information_personnelle', params: { id: id } });
     },
    creation() { this.$router.push({ name: 'create_consultation' }); },
    async getConsultations() {
       if (this.isFirstLoad) {
        this.isLoading = true;
        this.isFirstLoad = false;
      }
      try {
        const response = await api.getItems('consultations', {
          page: this.currentPage,
          itemsperpage: this.itemsperpage,
          orderBy: this.orderBy,
          sortOrder: this.sortOrder,
          search: this.searchQuery
        });
        const { data, meta } = response.data;
        this.consultations = data;
        this.totalItems = meta?.total_records || data.length;
      } catch (error) {
        console.error('Erreur de chargement des consultations :', error);
      } finally {
        this.isLoading = false;
      }
    },
     traiterConsultation(c){
      if(c.statut==='En attente' && c.estPaye==='Non payé'){ 
        alert('Paiement requis');
       }
      else if(c.statut==='Terminé'){ 

        alert('Consultation terminée'); 

      }
      else {
         this.$router.push({name:'traitement_consultation', params:{id:c.id}}); 
        }
    },
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.getConsultations();
      }
    }
  },
  watch: {
    searchQuery() { this.currentPage = 1; this.getConsultations(); },
    itemsperpage() { this.currentPage = 1; this.getConsultations(); },
    orderBy() { this.getConsultations(); },
    sortOrder() { this.getConsultations(); }
  },
  created() { this.getConsultations(); }
};
</script>

<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}
.form-control-clinique,
.form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 8px 12px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus,
.form-select-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}
.modern-table-clinique thead {
  background: linear-gradient(90deg, #8fd3f4, #0d6efd);
  color: #fff;
  font-weight: 600;
}
.modern-table-clinique tbody tr:hover {
  background-color: #e1f0ff;
  cursor: pointer;
  transition: all 0.3s ease;
}
.pagination-modern .page-link {
  border-radius: 50% !important;
  margin: 0 4px;
  min-width: 38px;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0d6efd;
  border: 1px solid #dee2e6;
}
.pagination-modern .page-item.active .page-link {
  background-color: #0d6efd;
  color: #fff;
  border-color: #0d6efd;
}
.pagination-modern .page-link:hover {
  background-color: #d1e7ff;
  transition: all 0.3s ease;
}

/* Responsive adjustments */
@media (max-width: 767px) {
  .table td, .table th {
    padding: 0.4rem 0.5rem;
    font-size: 0.75rem;
  }
  .btn-clinique {
    width: 100%;
  }
  .header-clinique {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>
